import { render, staticRenderFns } from "./UKHomeTop10Titles.vue?vue&type=template&id=4352a428&scoped=true"
import script from "./UKHomeTop10Titles.vue?vue&type=script&setup=true&lang=ts"
export * from "./UKHomeTop10Titles.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./UKHomeTop10Titles.vue?vue&type=style&index=0&id=4352a428&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4352a428",
  null
  
)

export default component.exports